'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var SortedMap = /*#__PURE__*/function (_Map, _Symbol$iterator) {
  _inherits(SortedMap, _Map);

  var _super = _createSuper(SortedMap);

  function SortedMap(entries, cmp) {
    var _this;

    _classCallCheck(this, SortedMap);

    _this = _super.call(this);
    _this._cmp = cmp || _this._defaultSort;
    _this._keys = [];

    var _iterator = _createForOfIteratorHelper(entries || []),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            k = _step$value[0],
            v = _step$value[1];

        _this.set(k, v);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return _this;
  }

  _createClass(SortedMap, [{
    key: "update",
    value: function update(i) {
      if (i < 0 || i >= this._keys.length) {
        return;
      }

      var k = this._keys[i];

      this._keys.splice(i, 1);

      var newIdx = this._find(k);

      this._keys.splice(newIdx, 0, k);
    }
  }, {
    key: "set",
    value: function set(k, v) {
      if (this.has(k)) {
        var _i = this.indexOf(k);

        this._keys.splice(_i, 1);
      }

      _get(_getPrototypeOf(SortedMap.prototype), "set", this).call(this, k, v);

      var i = this._find(k);

      this._keys.splice(i, 0, k);

      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      _get(_getPrototypeOf(SortedMap.prototype), "clear", this).call(this);

      this._keys = [];
    }
  }, {
    key: "delete",
    value: function _delete(k) {
      if (!this.has(k)) {
        return false;
      }

      var i = this.indexOf(k);

      this._keys.splice(i, 1);

      return _get(_getPrototypeOf(SortedMap.prototype), "delete", this).call(this, k);
    }
  }, {
    key: "indexOf",
    value: function indexOf(k) {
      if (!this.has(k)) {
        return -1;
      }

      var i = this._find(k);

      if (this._keys[i] === k) {
        return i;
      }

      for (var j = 1; j < this._keys.length; j++) {
        if (this._keys[i + j] === k) return i + j;
        if (this._keys[i - j] === k) return i - j;
      }

      return -1;
    }
  }, {
    key: "_find",
    value: function _find(k) {
      var lower = 0;
      var upper = this._keys.length;

      while (lower < upper) {
        var pivot = lower + upper >>> 1;

        var cmp = this._kCmp(this._keys[pivot], k);

        if (cmp < 0) {
          lower = pivot + 1;
        } else if (cmp > 0) {
          upper = pivot;
        } else {
          return pivot;
        }
      }

      return lower;
    }
  }, {
    key: "keys",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function keys() {
      var _iterator2, _step2, k;

      return _regeneratorRuntime.wrap(function keys$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(this._keys);
              _context.prev = 1;

              _iterator2.s();

            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 9;
                break;
              }

              k = _step2.value;
              _context.next = 7;
              return k;

            case 7:
              _context.next = 3;
              break;

            case 9:
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);

              _iterator2.e(_context.t0);

            case 14:
              _context.prev = 14;

              _iterator2.f();

              return _context.finish(14);

            case 17:
              return _context.abrupt("return", undefined);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, keys, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "values",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function values() {
      var _iterator3, _step3, k;

      return _regeneratorRuntime.wrap(function values$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iterator3 = _createForOfIteratorHelper(this._keys);
              _context2.prev = 1;

              _iterator3.s();

            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context2.next = 9;
                break;
              }

              k = _step3.value;
              _context2.next = 7;
              return this.get(k);

            case 7:
              _context2.next = 3;
              break;

            case 9:
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](1);

              _iterator3.e(_context2.t0);

            case 14:
              _context2.prev = 14;

              _iterator3.f();

              return _context2.finish(14);

            case 17:
              return _context2.abrupt("return", undefined);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, values, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "entries",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function entries() {
      var _iterator4, _step4, k;

      return _regeneratorRuntime.wrap(function entries$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _iterator4 = _createForOfIteratorHelper(this._keys);
              _context3.prev = 1;

              _iterator4.s();

            case 3:
              if ((_step4 = _iterator4.n()).done) {
                _context3.next = 9;
                break;
              }

              k = _step4.value;
              _context3.next = 7;
              return [k, this.get(k)];

            case 7:
              _context3.next = 3;
              break;

            case 9:
              _context3.next = 14;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](1);

              _iterator4.e(_context3.t0);

            case 14:
              _context3.prev = 14;

              _iterator4.f();

              return _context3.finish(14);

            case 17:
              return _context3.abrupt("return", undefined);

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, entries, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.delegateYield(this.entries(), "t0", 1);

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, value, this);
    })
  }, {
    key: "forEach",
    value: function forEach(cb, thisArg) {
      if (!cb) {
        return;
      }

      var _iterator5 = _createForOfIteratorHelper(this._keys),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var k = _step5.value;
          cb.apply(thisArg, [[k, this.get(k)]]);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "_defaultSort",
    value: function _defaultSort(a, b) {
      if (a[0] < b[0]) return -1;
      if (b[0] < a[0]) return 1;
      return 0;
    }
  }, {
    key: "_kCmp",
    value: function _kCmp(a, b) {
      return this._cmp([a, this.get(a)], [b, this.get(b)]);
    }
  }]);

  return SortedMap;
}( /*#__PURE__*/_wrapNativeSuper(Map), Symbol.iterator);

exports.SortedMap = SortedMap;